module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gradeCalcPage"
  }, [_c('div', {
    staticClass: "entries"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "header"
  }, [_vm._v("  Earned    Total")]), _vm._v(" "), _c('div', {
    staticClass: "cummGrades"
  }, _vm._l((_vm.grades), function(grade) {
    return _c('div', {
      staticClass: "grade"
    }, [_vm._v("\n  \t       "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (grade.pointsEarned),
        expression: "grade.pointsEarned"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (grade.pointsEarned)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          grade.pointsEarned = $event.target.value
        }
      }
    }), _vm._v("  \n  \t      "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (grade.pointsTotal),
        expression: "grade.pointsTotal"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (grade.pointsTotal)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          grade.pointsTotal = $event.target.value
        }
      }
    })])
  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('button', {
    staticClass: "btn-primary",
    on: {
      "click": _vm.addGrade
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    on: {
      "click": _vm.removeGrade
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    on: {
      "click": _vm.resetEntries
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('div', {
    staticClass: "output"
  }, [_c('h3', [_vm._v(" Your grade is " + _vm._s(_vm.calculateGrade) + "%")])])])]), _vm._v(" "), _c('div', {
    staticClass: "predGrade"
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("Enter remaining point category totals: ")]), _vm._v(" "), _c('div', {
    staticClass: "gradesToGo"
  }, _vm._l((_vm.predicts), function(grade) {
    return _c('div', {
      staticClass: "grade"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (grade.pointsPredict),
        expression: "grade.pointsPredict"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (grade.pointsPredict)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          grade.pointsPredict = $event.target.value
        }
      }
    })])
  })), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("Enter/Slide Desired Grade:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('vue-slider', {
    ref: "slider",
    attrs: {
      "min": 0,
      "max": 100,
      "width": 500
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    on: {
      "click": _vm.resetPred
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('div', {
    staticClass: "predOutput"
  }, [_c('h3', [_vm._v(" You need " + _vm._s(_vm.predictGrade) + " points to get a " + _vm._s(_vm.value) + "% in the class.")])])], 1), _vm._v(" "), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('u', [_vm._v("Current Grade")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "predHeader"
  }, [_c('u', [_vm._v("Predicted Grade")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e0d9fc7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cummulative.vue
// module id = 22
// module chunks = 0